import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetResourcesResponseBody,
  IApiPutResourcesQueryBody,
  IApiPutResourcesResponseBody,
} from './AppResourcesApi.types';

export class AppResourcesApi {
  public constructor(private client: ApiClient) {}

  public async prepareUpload(
    appId: string,
    body?: IApiPutResourcesQueryBody,
  ): Promise<IApiPutResourcesResponseBody> {
    const request: IApiJsonRequest = {
      path: '/files/resources/put',
      method: 'get',
      params: body,
    };

    const response = await this.client.fetchJson<IApiPutResourcesResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async getAll(appId: string): Promise<IApiGetResourcesResponseBody> {
    const request: IApiJsonRequest = {
      path: '/files/resources',
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetResourcesResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }
}
